// Also serialized into Get started's HTML, before the early HubSpot embed.
// Keep this function self-contained. Never read fields or send conversion IDs.
function installEnquiryTracking(browser) {
  if (!browser || browser.location.hostname !== "expend.com") return null
  if (browser.__expendEnquiryTracking) return browser.__expendEnquiryTracking

  const variants = {
    "2dce1b07-5327-4977-b1b7-fbc35f6794ce": "uk",
    "3d0b7ff1-2ff6-4709-b09d-7b4e1ccdaca5": "international",
  }
  const storageKey = "expend.enquiry.sent.v1"
  const sent = new Set()
  const engaged = new Set()
  let previousPath
  let viewed = false
  const path = () => browser.location.pathname.replace(/\/$/, "")
  const consented = () => {
    try {
      const state = browser.CookieScript.instance.currentState()
      return (
        state.action === "accept" &&
        Array.isArray(state.categories) &&
        state.categories.includes("performance")
      )
    } catch (_) {
      return false
    }
  }
  const active = () => path() === "/get-started" && consented()
  const emit = (event, variant, method) => {
    if (!active()) return false
    try {
      browser.dataLayer = browser.dataLayer || []
      browser.dataLayer.push({
        event,
        expend_enquiry: {
          form_variant: variant,
          measurement_method: method,
          page_location: "https://expend.com/get-started",
          page_referrer: "",
        },
      })
      return true
    } catch (_) {
      return false // Measurement must never interfere with the form.
    }
  }
  const onNavigation = () => {
    const currentPath = path()
    if (currentPath !== previousPath) {
      previousPath = currentPath
      viewed = false
      engaged.clear()
    }
    if (!viewed && active())
      viewed = emit("expend_enquiry_form_view", "none", "page_view")
  }
  const engage = (formId, method) => {
    if (!Object.prototype.hasOwnProperty.call(variants, formId)) return
    onNavigation()
    if (!engaged.has(formId) && active()) {
      engaged.add(formId)
      if (!emit("expend_enquiry_form_engaged", variants[formId], method))
        engaged.delete(formId)
    }
  }
  const focusedForm = () => {
    if (!active() || !browser.document.hasFocus()) return
    const frame = browser.document.activeElement
    if (frame?.tagName !== "IFRAME") return
    try {
      const url = new URL(frame.src)
      const formId = url.searchParams.get("_hsFormId")
      if (
        url.origin === "https://js.hsforms.net" &&
        url.pathname === "/ui-forms-embed-components-app/frame.html" &&
        url.searchParams.get("_hsPortalId") === "3856243" &&
        frame.closest(`[id="hs-form-root-${formId}"]`)
      )
        engage(formId, "iframe_focus")
    } catch (_) {
      // Other frames, malformed URLs and future vendor changes are ignored.
    }
  }
  const onFocus = () => browser.setTimeout(focusedForm, 0)
  const onStep = (event) => engage(event.detail?.formId, "form_step")
  const onSuccess = (event) => {
    if (!active()) return // No storage reads or replay of pre-consent events.
    const formId = event.detail?.formId
    if (!Object.prototype.hasOwnProperty.call(variants, formId)) return
    try {
      const form = browser.HubSpotFormsV4.getFormFromEvent(event)
      if (
        form.getFormId() !== formId ||
        !event.detail.instanceId ||
        form.getInstanceId() !== event.detail.instanceId
      )
        return
      const conversionId = form.getConversionId()
      if (
        typeof conversionId !== "string" ||
        !conversionId.trim() ||
        conversionId.length > 200
      )
        return
      const key = `${formId}:${conversionId}`
      if (sent.has(key)) return
      let stored = []
      try {
        const value = JSON.parse(browser.sessionStorage.getItem(storageKey))
        if (Array.isArray(value))
          stored = value.filter((item) => typeof item === "string").slice(-100)
      } catch (_) {
        // Blocked storage still permits document-local duplicate protection.
      }
      if (stored.includes(key)) return
      sent.add(key) // Protect against synchronous duplicate callbacks too.
      if (
        !emit("expend_enquiry_submitted", variants[formId], "hubspot_success")
      ) {
        sent.delete(key)
        return
      }
      try {
        // Consent-gated, tab-session-only duplicate protection; never sent.
        browser.sessionStorage.setItem(
          storageKey,
          JSON.stringify([...stored, key].slice(-100))
        )
      } catch (_) {}
    } catch (_) {
      // Missing vendor APIs must not affect submission or redirect behaviour.
    }
  }
  const consentEvents = [
    "CookieScriptLoaded",
    "CookieScriptAcceptAll",
    "CookieScriptAccept",
    "CookieScriptCurrentState",
  ]
  browser.addEventListener("hs-form-event:on-submission:success", onSuccess)
  browser.addEventListener("hs-form-event:on-interaction:navigate", onStep)
  browser.addEventListener("blur", onFocus)
  browser.document.addEventListener("focusin", onFocus)
  for (const name of consentEvents) browser.addEventListener(name, onNavigation)
  const tracker = { onNavigation }
  browser.__expendEnquiryTracking = tracker
  onNavigation()
  return tracker
}

module.exports = { installEnquiryTracking }
